import { render, staticRenderFns } from "./TrekkingView.vue?vue&type=template&id=cbfbcf6a&"
import script from "./TrekkingView.vue?vue&type=script&lang=ts&"
export * from "./TrekkingView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports